import StatsOverview from "./StatsOverview";
import { StatPeriodProvider } from "./StatPeriodContext";
import StatPeriodSelect from "./StatPeriodSelect";
import ChartThemePicker from "./shared/ChartThemePicker";
import { ChartThemeContext } from "./contexts/ChartThemeContext";
import { useState } from "react";
import { ChartTheme } from "./theme/chartColors";
import { usePage } from "@inertiajs/react";
import { UserStatsPageProps } from "pages/clientverse/users/stats/index.props";
import Text from "hardcover-ui/components/Text";

export default function StatsPage() {
  const [chartTheme, setChartTheme] = useState<ChartTheme>("colorful");
  const { stats } = usePage<UserStatsPageProps>().props;

  if (!stats) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Text>No stats data available</Text>
      </div>
    );
  }

  return (
    <StatPeriodProvider>
      <ChartThemeContext.Provider
        value={{ theme: chartTheme, setTheme: setChartTheme }}
      >
        <div className="relative min-h-screen">
          <StatsOverview />

          <div className="sticky bottom-20 xl:bottom-4 w-full flex justify-center z-50">
            <div className="flex items-center gap-1 border-2 border-secondary rounded-full dark:bg-gray-800/20 bg-white/20 backdrop-blur-md dark:backdrop-brightness-50 p-1 shadow-2xl">
              <StatPeriodSelect
                buttonClassName="hover:opacity-70 transition-all"
                textClassName="text-lg"
              />
              <ChartThemePicker value={chartTheme} onChange={setChartTheme} />
            </div>
          </div>
        </div>
      </ChartThemeContext.Provider>
    </StatPeriodProvider>
  );
}
